import React from 'react';
import dayjs from 'dayjs';
import styles from './AppointmentList.module.scss';

//material ui
import CardContent from '@material-ui/core/CardContent';
import { Card, CardHeader, Typography } from '@material-ui/core';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import ScheduleIcon from '@material-ui/icons/Schedule';

const AppointmentList = ({ appointment }) => {
	return (
		<div className={styles.appointment_card}>
			<Typography color='textPrimary' className={styles.appointment_name}>
				{appointment.appointmentMainName}
			</Typography>
			<Typography
				variant='body2'
				component='div'
				className={styles.appointment_card_main_content}
			>
				<div className={styles.date_group}>
					<CalendarTodayIcon />
					{dayjs(appointment.appointmentTime).format('DD/MM/YYYY')}
				</div>
				<div className={styles.time_group}>
					<ScheduleIcon />
					{dayjs(appointment.appointmentTime).format('hh:mm A')}
				</div>
			</Typography>
		</div>
	);
};

export default AppointmentList;
